import * as React from "react"
export const LockIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M17.0833 7.5H15.8333V5.83332C15.8333 2.6168 13.2166 0 10 0C6.78344 0 4.16668 2.6168 4.16668 5.83332V7.5H2.91668C2.68637 7.5 2.5 7.68637 2.5 7.91668V18.3334C2.5 19.2525 3.24746 20 4.16668 20H15.8334C16.7525 20 17.5 19.2525 17.5 18.3333V7.91668C17.5 7.68637 17.3136 7.5 17.0833 7.5ZM11.2476 16.204C11.2606 16.3216 11.2228 16.4396 11.1438 16.5279C11.0649 16.6162 10.9518 16.6667 10.8334 16.6667H9.16668C9.04828 16.6667 8.93516 16.6162 8.85621 16.5279C8.77727 16.4396 8.73941 16.3216 8.75246 16.204L9.01531 13.8404C8.58848 13.5299 8.33336 13.0387 8.33336 12.5C8.33336 11.5808 9.08082 10.8333 10 10.8333C10.9193 10.8333 11.6667 11.5808 11.6667 12.5C11.6667 13.0387 11.4116 13.5299 10.9848 13.8404L11.2476 16.204ZM13.3333 7.5H6.66668V5.83332C6.66668 3.99535 8.16203 2.5 10 2.5C11.838 2.5 13.3333 3.99535 13.3333 5.83332V7.5Z'
      fillRule='evenodd'
      clipRule='evenodd'
      stroke='currentColor'
      fill='currentColor'
    />
  </svg>
)
